<template>
  <a-modal title="选择工序" v-model="modalVisible" @ok="onConfirm" :confirmLoading="loading" destroyOnClose>
    <a-form-model ref="ruleFormRef" :model="materialForm" autoComplete="off" :wrapperCol="{ span: 19 }" :labelCol="{ span: 4 }">
      <a-form-model-item class="full-width" label="顺序号" :rules="[baseRequiredRule]" prop="operationSeqNum">
        <a-input-number class="full-width" v-model="materialForm.operationSeqNum"></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="工序编码" :rules="[baseRequiredRule]" prop="operationId">
        <global-select
          v-model="materialForm.operationId"
          requestApi="/bom/bomOperation/findList"
          :selectItem="{ value: 'selectedValue', label: 'realValue' }"
          :setParams="{ organizationCode: 'B041' || detailData.organizationCode}"
          :dropdown-match-select-width="false"
          :assembleLabel="true"
          @change="onChangeCode"
        />
      </a-form-model-item>
      <a-form-model-item label="类型" :rules="[baseRequiredRule]" prop="operationType">
        <ls-select-page
          v-model="materialForm.operationType"
          :datas="operationTypeList"
          searchKey="lookupValue"
          valueKey="lookupCode"
        >
          <template slot="select-option" slot-scope="{ items }">
            <a-select-option
              v-for="item in items"
              :key="item.lookupCode"
            >{{ item.lookupValue }}</a-select-option>
          </template>
        </ls-select-page>
      </a-form-model-item>
      <a-form-model-item label="是否防跳站" prop="skipFlag" :rules="[baseRequiredRule]">
        <a-select v-model="materialForm.skipFlag" style="width: 100%">
          <a-select-option v-for="item in skipFlagOptions" :key="item.value" :value="item.value">{{
            item.label
          }}</a-select-option> </a-select
        >
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import {
  apiAddBomRoutingLineCc
} from '@/api/mes/basedata/standardProcessNew'
import { IS_JUMP_STATION } from '../enums.js';
export default {
  name: 'ProcessSelectModal',
  components: {},
  props: {
    operationTypeList: {
      type: Array,
      default: () => []
    },
    operationCodeList: {
      type: Array,
      default: () => []
    },
    detailData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    this.inputRequiredRule = { required: true, message: ' ', whitespace: true }
    this.baseRequiredRule = { required: true, message: ' ' }
    return {
      modalVisible: false,
      loading: false,
      materialForm: {}
    }
  },
  computed: {
    skipFlagOptions() {
      return Object.values(IS_JUMP_STATION)
    }
  },
  methods: {
    show() {
      this.modalVisible = true;
      this.materialForm = {};
    },
    onClose() {
      this.modalVisible = false;
    },
    onChangeCode(value, list) {
      const item = list.find(item => item.selectedValue === value);
      this.materialForm.operation_desc = item.realValue;
    },
    onConfirm() {
      this.$refs.ruleFormRef.validate(valid => {
        if(valid) {
          this.loading = true;
          const { id: routingId } = this.detailData;
          apiAddBomRoutingLineCc({ routingId, ...this.materialForm }).then(res => {
            if(res.code === 200) {
              this.$message.success('操作成功');
              this.$emit('successCall');
              this.onClose();
            }
          }).finally(() => {
            this.loading = false;
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}
</style>
